// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleLoginButton_googleButton__2+Vhg","icon":"GoogleLoginButton_icon__PEwi8"};